import { useEffect } from 'react';
import { Routes, Route, Navigate, NavLink, Link, useLocation } from 'react-router-dom';
import { useStore } from './lib/useStore.jsx';
import Wall from './routes/Wall.jsx';
import Skill from './routes/Skill.jsx';
import Who from './routes/Who.jsx';
import Setup from './routes/Setup.jsx';
import Parent from './routes/Parent.jsx';
import ChooseSkills from './routes/ChooseSkills.jsx';
import { DoorIcon, WallIcon, PeopleIcon, GrownUpIcon } from './ui/Icons.jsx';

function Frame({ children }) {
  const { active } = useStore();
  const loc = useLocation();
  // A new screen starts at the top; the wall was opening half-scrolled after a long form.
  useEffect(() => { window.scrollTo(0, 0); }, [loc.pathname]);
  const inParent = loc.pathname.startsWith('/parent');
  return (
    <div className="app">
      <header className="topbar">
        <Link to="/" className="brand"><DoorIcon width="26" height="26" /> Can Do</Link>
        {active && !inParent && <Link to="/who" className="btn small quiet">{active.name}</Link>}
      </header>
      {children}
      <nav className="tabbar" aria-label="Main">
        <NavLink to="/" end><WallIcon />My wall</NavLink>
        <NavLink to="/who"><PeopleIcon />Who</NavLink>
        <NavLink to="/parent"><GrownUpIcon />Grown-ups</NavLink>
      </nav>
    </div>
  );
}

export default function App() {
  const { store } = useStore();
  const hasKids = store.profiles.length > 0;
  return (
    <Frame>
      <Routes>
        <Route path="/" element={hasKids ? <Wall /> : <Navigate to="/setup" replace />} />
        <Route path="/skill/:id" element={hasKids ? <Skill /> : <Navigate to="/setup" replace />} />
        <Route path="/who" element={<Who />} />
        <Route path="/setup" element={<Setup />} />
        <Route path="/parent" element={<Parent />} />
        <Route path="/parent/child/:id" element={<ChooseSkills />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Frame>
  );
}
